import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Vital options array using correct paths from Routes.js
const vitalOptions = [
  {
    key: "bloodpressure",
    label: "Blood Pressure",
    icon: "monitor_heart",
    to: "/admin/patientmanagement/vitals/bloodpressure",
  },
  {
    key: "temperature",
    label: "Temperature",
    icon: "device_thermostat",
    to: "/admin/patientmanagement/vitals/temperature",
  },
  {
    key: "heartrate",
    label: "Heart Rate",
    icon: "favorite",
    to: "/admin/patientmanagement/vitals/heartrate",
  },
  {
    key: "respirationrate",
    label: "Respiration Rate",
    icon: "air",
    to: "/admin/patientmanagement/vitals/respirationrate",
  },
  {
    key: "oxygensaturation",
    label: "Oxygen Saturation",
    icon: "bloodtype",
    to: "/admin/patientmanagement/vitals/oxygensaturation",
  },
  {
    key: "height",
    label: "Height",
    icon: "height",
    to: "/admin/patientmanagement/vitals/height",
  },
  {
    key: "headcircumference",
    label: "Head Circumference",
    icon: "circle",
    to: "/admin/patientmanagement/vitals/headcircumference",
  },
  {
    key: "weight",
    label: "Weight",
    icon: "scale",
    to: "/admin/patientmanagement/vitals/weight",
  },
];

const VitalCommonheader = ({ activeOption = "" }) => {
  const { t } = useTranslation(); //for translation

  return (
    <div className="inner-menu-container bg-white shadow-sm mb-4">
      <div className="container-fluid">
        <ul className="nav secondary-menu mw-100 flex-nowrap gap-1 gap-sm-2 gap-lg-3 flex-fill fs-sm fw-semibold text-center border-0 text-nowrap overflow-x-auto overflow-y-hidden">
          {vitalOptions.map((option) => (
            <li
              className="nav-item flex-fill"
              role="presentation"
              key={option.key}
            >
              <Link
                to={option.to}
                className={`d-flex align-items-center justify-content-center gap-2 rounded-10 text-black px-2 px-sm-3 py-3 py-sm-4 position-relative ${
                  activeOption === option.key ? " active" : ""
                }`}
              >
                <span className="d-block material-symbols-outlined icon-lg">
                  {option.icon}
                </span>
                <span className="d-block">{t(option.label)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default VitalCommonheader;
